export const FLAG_SIZES = {
    headerIcon: { width: 24, height: 16 },
    listItem: { width: 24, height: 18 },
    card: { width: 27, height: 20 }
} as const

export type FlagSizeKey = keyof typeof FLAG_SIZES
